<template>
  <v-container fluid
               class="AppCompose">
    <v-form ref="form"
            @submit.prevent="send"
            autocomplete="off">

      <v-card id="emailPanel"
              ref="emailPanel">

        <div class="pa-4">
          <div class="d-flex flex align-center">

            <v-dialog v-model="showTemplateDialog"
                      fullscreen
                      hide-overlay
                      transition="dialog-bottom-transition">
              <v-card>
                <v-toolbar color="primary"
                           dark
                           flat
                           tile>
                  <v-toolbar-title>
                    Pick a template
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon
                         dark
                         @click="showTemplateDialog = false">
                    <v-icon>
                      fal fa-times
                    </v-icon>
                  </v-btn>
                </v-toolbar>
                <template-picker :form="form"
                                 :templates="templates"
                                 @selected="selectTemplate">
                </template-picker>
              </v-card>
            </v-dialog>

            <v-text-field v-model="templateName"
                          ref="templateTextField"
                          label="Pick a template (optional)"
                          placeholder=" "
                          prepend-inner-icon="fal fa-envelope-square"
                          @click:prepend-inner="toggleTemplateDialog"
                          @click="toggleTemplateDialog"
                          readonly
                          clearable
                          @click:clear="clearTemplate"
                          :error-messages="form.errors.get('template_id')">
            </v-text-field>
          </div>

          <div class="">
            <v-dialog v-if="editedContact"
                      v-model="editDialog"
                      @click:outside="closeEditDialog"
                      max-width="800px">
              <v-form @submit.prevent="saveContact">
                <v-card>
                  <v-card-title class="pb-0"
                                v-if="editedContact.id">
                    Edit Contact
                  </v-card-title>
                  <v-card-title class="pb-0"
                                v-else>
                    New Contact
                  </v-card-title>
                  <v-card-text>
                    <user-contact-form :contact="form.contact"
                                       :form="editContactForm">
                    </user-contact-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn type="submit"
                           color="primary"
                           @click.prevent="saveContact">
                      Save
                    </v-btn>
                    <v-btn @click.prevent="closeEditDialog">
                      Cancel
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-dialog>
            <v-combobox v-model="form.contact"
                        ref="contactCombo"
                        @change="checkContact(true)"
                        :search-input.sync="search"
                        :loading="contactsBusy"
                        :items="normalizedContacts"
                        item-text="name_email"
                        class="pt-0 AppCompose_ContactList"
                        hide-no-data
                        label="To"
                        placeholder="Search for your recipient or type an email address and press ENTER."
                        :hint="form.contact ? 'If necessary, click the pencil icon to edit their name or other details.' : ''"
                        persistent-hint
                        return-object
                        validate-on-blur
                        :rules="[rules.required, rules.objectEmail]"
                        :error-messages="form.errors.get('contact')">
              <template v-slot:item="{item: contact}">
                <div v-if="contact.name && contact.company_name"
                     class="AppCompose__ContactListItem">
                  <div class="AppCompose__ContactListItemField">
                    {{ contact.email }}
                  </div>
                  <div class="AppCompose__ContactListItemField">
                    {{ contact.name_with_salutation }}
                  </div>
                  <div class="AppCompose__ContactListItemField">
                    {{ contact.company_name }}
                  </div>
                </div>
                <div v-else-if="contact.name"
                     class="AppCompose__ContactListItem">
                  <div class="AppCompose__ContactListItemField">
                    {{ contact.email }}
                  </div>
                  <div class="AppCompose__ContactListItemField">
                    {{ contact.name_with_salutation }}
                  </div>
                </div>
                <div v-else
                     class="AppCompose__ContactListItem">
                  <div class="AppCompose__ContactListItemField">
                    {{ contact.email }}
                  </div>
                </div>
              </template>
              <template v-slot:selection="{parent, item, index, select, selected, disabled}">
                <v-chip close
                        @click:close="clearContact"
                        @click.stop="editContact">
                  <v-icon left
                          small>
                    fal fa-fw fa-pencil
                  </v-icon>
                  <div>
                    {{ item.name_email }}
                  </div>
                </v-chip>
              </template>
            </v-combobox>
          </div>

          <div class="">
            <v-text-field v-model="form.subject"
                          ref="subject"
                          :disabled="isEditorDisabled"
                          label="Subject"
                          placeholder=" "
                          :rules="[rules.required]"
                          counter
                          maxlength="150"
                          clearable
                          @blur="saveDraft(true)"
                          :error-messages="form.errors.get('subject')">
            </v-text-field>
          </div>

          <div v-if="isTemplateTinyMCE"
               class="d-flex justify-space-between align-center">
            <div>
              <template v-if="isEditorEnabled && presentationID && canSelectContent">
                <div class="text--caption">
                  Put your cursor in the body where you want to insert the link. Then press <strong>Insert Link</strong>.
                </div>
                <v-btn v-if="1===2"
                       color="primary"
                       :disabled="!canSelectContent"
                       class="mb-2"
                       @click.prevent="createLinks">
                  <template v-if="presentation">
                    Insert Link to {{ presentation.name }}
                  </template>
                  <template v-else>
                    Insert Link
                  </template>
                </v-btn>
              </template>
              <template v-else-if="isEditorEnabled && canSelectContent">
                <div class="text--caption">
                  Put your cursor in the body where you want to insert the links. Then press <strong>Insert Links</strong>.
                </div>
                <v-btn v-if="1===2"
                       color="secondary"
                       :disabled="!canSelectContent"
                       class="mb-4"
                       id="btn_select_content">
                  Select Content
                </v-btn>
                <content-picker-dialog :form="form"
                                       :show="showContentPicker"
                                       @close="closeContentPicker"
                                       @insert="createLinks">
                </content-picker-dialog>
              </template>
            </div>
            <div v-if="draftsEnabled"
                 class="pt-1 pb-4">
              <template v-if="draftBusy">
                <v-icon>
                  fal fa-spin fa-spinner
                </v-icon>
                Saving
              </template>
              <template v-else>
                <v-icon color="success">
                  fal fa-check-circle
                </v-icon>
                Saved
              </template>
            </div>
          </div>

          <div v-if="isTemplateTinyMCE"
               id="tinyContainer"
               class="form-group"
               :class="{'has-error': form.errors.has('body')}"
               :style="`min-height: ${tinyMinHeight}px`">
            <tinymce-editor v-if="mounted"
                            api-key="w7qx9l4xwuc114tjfvqngdobxbi48cjwt782qof3qt0ht031"
                            id="tinyEditor"
                            :init="tinyConfig"
                            v-model="form.html_body"
                            @onBlur="saveDraft(true)">
            </tinymce-editor>
          </div>
          <div v-else>
            <v-responsive class="iframe-container"
                          :aspect-ratio="16/9">
              <iframe :src="dataURI">
              </iframe>
            </v-responsive>
          </div>

        </div>

        <ShareTemplateErrors :form="form"
                             :template="template">
        </ShareTemplateErrors>

        <v-card-actions class="py-1 px-4">
          <div class="d-md-flex flex-md-grow-1">
            <v-btn @click.prevent="send"
                   :disabled="!isFormValid"
                   color="primary"
                   class="mr-4">
              Send
            </v-btn>

            <v-btn @click.prevent="resetComposeForm"
                   class="mr-4">
              Reset
            </v-btn>

            <div class="mr-4">
              <v-checkbox v-model="form.send_receipt"
                          hide-details
                          label="Send me a confirmation"
                          class="ma-0">
              </v-checkbox>
            </div>

            <div class="mr-4">
              <v-checkbox v-model="form.is_test"
                          hide-details
                          label="Check if this is a test email."
                          class="ma-0">
              </v-checkbox>
            </div>

            <v-dialog v-model="showSettings">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs"
                       text
                       v-on="on">
                  <v-icon left>
                    fal fa-cogs
                  </v-icon>
                  Settings
                </v-btn>
              </template>

              <v-card flat
                      tile>
                <v-toolbar color="primary"
                           tile
                           flat
                           dark>
                  <v-toolbar-title>
                    Settings
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text class="flex-grow-1">
                  <v-radio-group v-model="form.notification_level"
                                 label="Notifications"
                                 hint="Do you want to be notified when the recipient clicks a link?"
                                 persistent-hint>
                    <v-radio v-for="level in notificationLevels"
                             :key="level.id"
                             :value="level.id"
                             :label="level.name">
                    </v-radio>
                  </v-radio-group>

                </v-card-text>
                <v-card-actions>
                  <v-btn color="primary"
                         @click.prevent="showSettings = !showSettings">
                    Save Settings
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <template v-if="draftsEnabled">
              <v-spacer>
              </v-spacer>

              <div v-if="draftBusy">
                <v-icon>
                  fal fa-spin fa-spinner
                </v-icon>
                Saving
              </div>
              <div v-else>
                <v-icon color="success">
                  fal fa-check-circle
                </v-icon>
                Saved
              </div>
            </template>
          </div>

          <v-snackbar v-model="form.successful"
                      top
                      centered
                      outlined
                      color="success"
                      tile>
            <strong>
              Your email will be sent!
            </strong>
          </v-snackbar>

        </v-card-actions>
      </v-card>
      <pre v-if="1===2 && user.is_employee">{{ form.data() }}</pre>
    </v-form>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import formValidation from '../../plugins/formValidation';
import sharedLinkService from '../../../../ml/services/sharedLinkService';
import shareTemplateService from '../../../../ml/services/shareTemplateService';
import tinymceService from '../../../../ml/services/tinymceService';
import pluralize from 'pluralize';
import presentationService from '../../../../ml/services/presentationService';
import jssha from '../../../../plugins/jssha';
import emailService from '../../../../ml/services/emailService';
import validationService from '../../services/validationService';
import {cloneDeep, find, isArray, isInteger, isNull, isObject, isString} from 'lodash';
import localforage from 'localforage';
import blockedRecipientService from '../../services/blockedRecipientService';
import subscriberService from '../../../../ml/services/subscriberService';
import slugify from 'slugify';
import UserContactForm from '../user-contacts/components/UserContactForm';
import userContactService from '../../services/userContactService';
import TemplatePicker from './components/TemplatePicker';
import HelpDialog from '../../components/HelpDialog';
import ContentPickerDialog from './wizard/components/ContentPickerDialog';
import DOMPurify from 'dompurify';
import htmlService from '../../services/htmlService';
import ShareTemplateErrors from '../share_templates/components/ShareTemplateErrors.vue';

localforage.setDriver(localforage.LOCALSTORAGE);

// MLD-2391
const DRAFT_KEY = 'AppCompose.draft';
const DRAFT_INTERVAL = 10000;

export default {
  components: {ShareTemplateErrors, ContentPickerDialog, HelpDialog, TemplatePicker, UserContactForm},
  mixins: [formValidation],
  data() {
    return {
      draftsEnabled: false,
      editContactForm: new Form(userContactService.initForm()),
      editDialog: false,
      editedContact: null,
      debug: false,
      showContentPicker: false,
      showSettings: false,
      busy: false,
      contactsBusy: false,
      contacts: [],
      editor: null,
      editorEnabled: false,
      mounted: true,
      autoSave: true, // MLD-2391
      draftBusy: false, // MLD-2391
      draftInterval: null, // MLD-2391
      error: null,
      filter: {
        name: '',
        type: '',
      },
      form: new Form({
        version: 1,
        template_id: '',
        to: '',
        contact: null,
        presentations: [],
        subject: '',
        html_body: '',
        include_images: false,
        is_test: false, // MLD-2066
        notification_level: 2,
        recipients: [],
        send_receipt: true, // MLD-2277
      }),
      links: [],
      notificationLevels: sharedLinkService.getNotificationLevels(),
      presentation: null,
      presentations: [],
      search: '', // MLD-2712
      showContactHelp: false, // MLD-2279
      showSubjectHelp: false, // MLD-2279
      showTemplateHelp: false, // MLD-2279
      showTemplateDialog: false, // MLD-2653
      templateName: null, // MLD-2653
      templates: [],
      templateMenuProps: {
        activator: '#fake',
        closeOnClick: true,
        openOnClick: false,
      },
    }
  },
  beforeDestroy() {
    if (this.draftInterval) { // MLD-2391
      clearInterval(this.draftInterval);
    }
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ]),
    dataURI() { // MLD-2473
      if (this.form.html_body) {
        return htmlService.dataURI(this.form.html_body);
      }
      return null;
    },
    template() {
      if (this.form.template_id) {
        return find(this.templates, t => t.id === this.form.template_id);
      }
      return null;
    },
    isTemplateTinyMCE() { // MLD-2473
      const template = this.template;
      if (template) {
        return template.is_tinymce;
      }
      return true;
    },
    userContactID() { // MLD-2588
      const userContactID = parseInt(this.$route.query.user_contact_id);
      if (isInteger(userContactID)) {
        return userContactID
      }
      return null;
    },
    queryContact() { // MLD-2498
      if (this.userContactID) { // MLD-2588
        return find(this.contacts, c => c.id === this.userContactID);
      } else if (this.$route.query.first_name
        && this.$route.query.last_name
        && this.$route.query.email) {
        const name = `${this.$route.query.first_name} ${this.$route.query.last_name}`
        const slug = slugify(name, {replacement: '_', lower: true,});
        const email = this.$route.query.email;
        return {
          id: slug,
          first_name: this.$route.query.first_name,
          last_name: this.$route.query.last_name,
          name: name,
          slug: slug,
          email: email,
          name_email: `${name} <${email}>`,
        }
      } else if (this.$route.query.email) {
        return find(this.userContacts, c => c.email === this.$route.query.email);
      }
      return null;
    },
    redirect() {
      return this.$route.query.redirect;
    },
    redirectBack() {
      return this.redirect && this.redirect === 'back';
    },
    normalizedContacts() {
      return this.contacts;
      //let contacts = this.contacts.filter(c => !!c.email);
      //return orderBy(contacts, ['slug', 'email'], ['asc', 'asc']);
    },
    presentationID() {
      const presentationID = parseInt(this.$route.query.presentationID);
      if (isInteger(presentationID)) {
        return presentationID;
      }
      return null;
    },
    isEnvironmentApp() {
      return this.$route.meta
        && this.$route.meta.layout === 'mobile';
    },
    isEnvironmentWeb() {
      return !this.isEnvironmentApp;
    },
    isFormValid() {
      if (!this.form.to) {
        return false;
      }
      if (!this.form.subject) {
        return false;
      }
      if (!this.form.html_body) {
        return false
      }
      return true;
    },
    insertButtonLabel() {
      return pluralize('Link', this.form.presentations.length, true);
    },
    canSelectContent() {
      return validationService.isEmailValid(this.form.to);
    },
    canSelectPresentations() {
      if (this.form.html_body.trim()) {
        return true;
      }
      return false;
    },
    canInsertLinks() {
      if (!this.form.presentations.length) {
        return false;
      }
      return true;
    },
    filteredPresentations() {
      return this.presentations.filter(p => {
        if (!p.can_be_shared) {
          return false;
        }
        if (this.filter.name && p.name.toLowerCase().indexOf(this.filter.name.toLowerCase()) === -1) {
          return false;
        }
        if (this.filter.type && p.presentation_type !== this.filter.type) {
          return false;
        }
        return true;
      })
    },
    recipients() {
      if (isObject(this.form.contact)) {
        return [
          {
            id: this.form.contact.id,
            user_contact_id: this.form.contact.id, // MLD-2503
            uuid: this.form.contact.uuid,
            salutation: this.form.contact.salutation,
            first_name: this.form.contact.first_name,
            last_name: this.form.contact.last_name,
            name: this.form.contact.name,
            designation: this.form.contact.designation,
            email: this.form.contact.email,
          }
        ]
      } else if (isString(this.form.to)) {
        const email = this.form.to.trim().toLowerCase();
        if (email) {
          return [
            {
              id: jssha.sha1(email),
              user_contact_id: null,
              salutation: null,
              first_name: null,
              last_name: null,
              name: null,
              designation: null,
              email: email,
            }
          ];
        }
      }
      return [];
    },
    tinyMinHeight() {
      const defaultHeight = 305;
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 220
        case 'sm':
          return defaultHeight
        case 'md':
          return defaultHeight
        case 'lg':
          return defaultHeight
        case 'xl':
          return defaultHeight
      }
    },
    tinyHeight() {
      /*const tinyContainer = document.getElementById('tinyContainer');
      if (tinyContainer) {
        console.log('TC', window.innerHeight, tinyContainer.getBoundingClientRect().top);
        return window.innerHeight - 150 - tinyContainer.getBoundingClientRect().top;
      }*/
      return this.tinyMinHeight;
    },
    tinyConfig() {
      const tags = [
        'email',
        'team_name',
        'user_name',
        'user_first_name',
        'user_last_name',
        'user_email',
        'user_phone',
        'user_phone_raw', // MLD-4632
        'user_title',
        'user_signature',
      ];

      const config = {
        selector: 'textarea#tm',
        resize: true,
        min_height: this.tinyMinHeight,
        height: this.tinyHeight,
        menubar: '',
        quickbars_insert_toolbar: 'ml_quick_insert', // MLD-2693 @see https://www.tiny.cloud/docs/plugins/opensource/quickbars/#exampledisablingthequickinsertcontexttoolbar
        quickbars_selection_toolbar: 'bold italic | quicklink', // MLD-2693 @see https://www.tiny.cloud/docs/plugins/opensource/quickbars/#quickbars_selection_toolbar
        toolbar: 'fullscreen | preview | ml_insert | undo redo | bold italic underline removeformat | numlist bullist | link | visualaid',
        style_formats_autohide: true,
        init_instance_callback: this.tinyInitialized,
        visual: false, // @see https://www.tiny.cloud/docs/configure/content-appearance/#visual
        setup: (editor) => {
          editor.on('init', e => {
            //editor.ui.disable();
          });
          this.editor = editor;
          editor.ui.registry.addButton('ml_quick_insert', { // MLD-2693 @see https://www.tiny.cloud/docs/ui-components/toolbarbuttons/
            text: 'Insert links here',
            tooltip: 'Insert links to content at this cursor location',
            onAction: () => {
              this.toggleContentPicker();
            },
          })
          editor.ui.registry.addButton('ml_insert', { // MLD-2693 @see https://www.tiny.cloud/docs/ui-components/toolbarbuttons/
            text: 'Insert links',
            tooltip: 'Insert links at the current cursor location',
            onAction: () => {
              this.toggleContentPicker();
            },
          })
          editor.ui.registry.addMenuButton('ml_tags', {
            text: 'Tags',
            fetch: function (callback) {
              let items = tags.map(tag => {
                return {
                  type: 'menuitem',
                  text: tag,
                  onAction: function () {
                    editor.insertContent(`{{${tag}}}`);
                  }
                }
              });
              callback(items);
            }
          })
        },
      }
      return tinymceService.getConfig(config);
    },
    isEditorEnabled() {
      return this.editorEnabled
    },
    isEditorDisabled() {
      return !this.isEditorEnabled
    },
  },
  watch: {
    search(val) {
      console.log(val);
      if (val && val !== this.form.contact) {
        this.searchContacts(val);
      }
    },
  },
  async created() {
    await this.$router.replace({name: `${this.$root.$routePrefix}.email.wizard`, query: this.$route.query});

    // MLD-2391
    /*if (this.presentationID) {
      await this.deleteDraft();
    } else if (this.userContactID) { // MLD-2588
      await this.deleteDraft();
      this.form.contact = this.queryContact;
      this.setContact(false);
    } else {
      await this.loadDraft();
    }
    this.initAutoSave();

    if (this.presentationID) {
      this.form.presentations = [this.presentationID];
    }

    this.fetchData();*/
  },
  methods: {
    searchContacts(query) {
      this.contactsBusy = true;
      const form = {
        query: query,
      }
      return userContactService.search(form, this.user)
        .then(data => {
          if (isArray(data.hits)) {
            this.contacts = data.hits;
          } else {
            this.contacts = data;
          }
        })
        .finally(() => {
          this.contactsBusy = false;
        })
    },
    toggleContentPicker() {
      if (!this.canSelectContent) {
        alert('Set a recipient first.');
        this.$refs.contactCombo.focus();
        return;
      }
      this.showContentPicker = true;
    },
    initAutoSave() { // MLD-2391
      if (this.autoSave) {
        this.draftInterval = setInterval(this.saveDraft, DRAFT_INTERVAL);
        if (this.debug) console.log('auto save initialized');
      } else {
        if (this.debug) console.log('auto save not initialized');
      }
    },
    async deleteDraft() { // MLD-2391
      await localforage.removeItem(DRAFT_KEY).catch(() => {
      });
    },
    async getDraft() {
      try {
        return await localforage.getItem(DRAFT_KEY);
      } catch (e) {
        if (this.debug) console.log(`getDraft exception: ${e.message}`, e);
        return null;
      }
    },
    async loadDraft() { // MLD-2391
      if (this.draftsEnabled) {
        const draft = await this.getDraft()
        if (draft) {
          this.form.version = draft.version;
          this.form.contact = this.queryContact ? this.queryContact : draft.contact;
          this.form.html_body = draft.html_body;
          this.form.presentations = draft.presentations;
          this.form.subject = draft.subject;
          this.form.template_id = draft.template_id;
          if (this.template) {
            this.templateName = this.template.name;
          }
          this.setContact(false);
          if (draft.html_body) {
            this.insertContent(draft.html_body, true);
          }
          if (this.form.to) {
            this.enableEditor();
          }
          if (this.debug) console.log('loaded draft', draft);
        } else {
          if (this.debug) console.log('draft was NULL');
          if (this.queryContact) { // MLD-2498
            this.form.contact = this.queryContact;
            this.setContact(false);
          }
        }
      }
    },
    getHTMLBody() {
      if (this.isTemplateTinyMCE && this.editor) {
        return this.editor.getContent();
      }
      return this.form.html_body;
    },
    async saveDraft(force = false) { // MLD-2391
      if (this.draftsEnabled) {
        const saved = await this.getDraft();
        if (!force
          && saved
          && saved.html_body === this.getHTMLBody()
          && saved.version === this.form.version) {
          if (this.debug) console.log('no change to draft');
          return;
        }
        if (this.debug) console.log('saving draft, force', force);
        this.draftBusy = true;
        const draft = {
          contact: this.form.contact,
          html_body: this.getHTMLBody(),
          presentations: this.form.presentations,
          subject: this.form.subject,
          template_id: this.form.template_id,
          version: this.form.version + 1,
        }
        await localforage.setItem(DRAFT_KEY, draft)

        this.form.version = this.form.version + 1;

        setTimeout(() => {
          this.draftBusy = false;
          console.log('saved draft', draft);
        }, 500);
      }
    },
    tinyInitialized(editor) {
      //console.log('tinyInitialized', editor);
    },
    closeContentPicker() {
      this.showContentPicker = false;
    },
    createLinks() {
      if (!this.canInsertLinks) {
        return;
      }
      const form = {
        expires_at: null,
        notification_level: this.form.notification_level,
        presentation_id: this.form.presentations,
        send_now: false,
        send_receipt: false,
        send_reminders: false,
        source: 'compose',
        is_test: this.form.is_test, // MLD-2066
      };
      sharedLinkService.bulkSharePresentations(form)
        .then(data => {
          this.links = data;
          this.insertLinks(this.links);
          this.form.presentations = [];
          if (this.presentationID) {
            this.form.presentations = [this.presentationID];
          }
          this.showContentPicker = false;
        })
        .catch(err => {
          this.$toast.error(`There was a problem creating the links.`, {timeout: 3000});
        })
    },
    fetchData() {
      if (this.presentationID) {
        presentationService.getPresentation(this.presentationID)
          .then(data => {
            this.presentation = data;
          })
          .catch(err => {
            this.$toast.error(`There was a problem retrieving presentation ${DOMPurify.sanitize(this.presentationID)}.`);
          })
      }
      presentationService.getPresentationsForCurrentUser()
        .then(data => {
          this.presentations = data
        })
        .catch(err => {
          this.presentations = [];
          this.$toast.error('There was a problem retrieving the presentations.');
        })
        .finally(() => {
          this.busy = false;
          this.fetchedPresentations = true;
        })
      shareTemplateService.getTemplatesForUser()
        .then(data => {
          this.templates = data.filter(template => { // MLD-2290
            if (template.is_default) {
              return false;
            }
            if (!template.is_app) {
              return false;
            }
            return true;
          });
        })
        .catch(err => {
          this.$toast.error('There was a problem retrieving the templates.');
        })
    },
    cancelInsertLinks() {
      this.form.presentations = [];
      this.showContentPicker = false;
    },
    insertLinks(links) {
      const items = [];
      links.forEach(link => {
        if (link.presentation) {
          let linkHTML = link.html.plain;
          if (this.form.include_images) {
            if (link.html.page_thumbnail) {
              linkHTML = link.html.page_thumbnail;
            } else if (link.html.thumbnail) {
              linkHTML = link.html.thumbnail;
            }
          }
          items.push(linkHTML);
        }
      });
      const content = `${items.join('')}`;
      this.insertContent(content);
    },
    insertContent(content, overwrite = false) {
      if (this.isTemplateTinyMCE) {
        // @see https://www.tiny.cloud/docs/api/tinymce/root_tinymce/#get
        if (this.editor) {
          if (overwrite) {
            this.editor.setContent(content)
            this.editor.setDirty(true);
          } else {
            // @see https://www.tiny.cloud/docs/api/tinymce/root_tinymce/#execcommand
            if (this.editor.execCommand('insertHTML', false, content)) {
              //console.log('insertHTML worked');
            } else {
              this.$toast.warning('insertHTML failed', {timeout: 3000});
            }
          }
          this.saveDraft(true);
        } else {
          this.$toast.warning('Could not get the editor', {timeout: 3000});
        }
      } else {
        this.form.html_body = content;
        this.saveDraft(true);
      }
    },
    clearContact() {
      this.form.contact = null;
      this.checkContact(true);
    },
    async checkContact(force = false) {
      console.log('checkContact()', this.form.contact);
      let email = null;
      if (isObject(this.form.contact)) {
        email = this.form.contact.email;
      } else if (isString(this.form.contact)) {
        email = this.form.contact;
        this.form.contact = {
          id: null,
          first_name: null,
          last_name: null,
          email: email,
          name_email: email,
          company_name: null,
          is_active: true,
          sync_from_crm: true,
        };
      }
      if (email) {
        if (await blockedRecipientService.isBlocked(email)) {
          this.form.errors.set('contact', 'Your company\'s policy prevents you from emailing that recipient.');
        } else if (await subscriberService.isUnsubscribed(email)) {
          this.form.errors.set('contact', 'You cannot email that recipient because they are unsubscribed.');
        } else {
          this.setContact(force);
          this.selectTemplate();
          if (isNull(this.form.contact.id) || !this.form.first_name || this.form.first_name === 'TBD') {
            this.editContact();
          }
        }
      } else {
        this.setContact(force);
      }
      setTimeout(() => {
        this.$refs.contactCombo.blur();
      }, 500);
    },
    setContact(force = false) { // MLD-2279
      if (isObject(this.form.contact)) {
        this.form.to = this.form.contact.email
      } else if (isString(this.form.contact)) {
        console.log('this.form.contact is a string')
        this.form.to = this.form.contact;
        this.form.contact = {
          email: this.form.contact,
          name_email: this.form.contact,
        }
      } else {
        this.form.to = null;
        this.form.contact = null;
        this.disableEditor();
      }
      this.saveDraft(force);
    },
    toggleTemplateDialog() {
      console.log('toggleTemplateDialog()');
      this.showTemplateDialog = true;
    },
    clearTemplate() {
      console.log('clearTemplate()', this.templateName);
      this.$refs.templateTextField.blur();
      this.showTemplateDialog = false;
      this.form.template_id = null;
      this.templateName = null;
    },
    disableEditor() {
      if (this.editor && this.editor.ui) {
        this.editor.ui.disable();
        this.editor.mode.set('readonly');
      }
      this.editorEnabled = false;
      console.log('disabled editor');
    },
    enableEditor() {
      if (!this.form.to) {
        console.log('Editor cannot be enabled until a recipient is set.');
        this.disableEditor();
        return;
      }
      if (this.editor && this.editor.ui) {
        this.editor.ui.enable();
        this.editor.mode.set('design');
      }
      this.editorEnabled = true;
      console.log('enabled editor');
    },
    selectTemplate() {
      console.log('selectTemplate()');
      this.$refs.templateTextField.blur();
      this.showTemplateDialog = false;
      if (this.template) {
        this.links = []; // MLD-2698
        this.templateName = this.template.name;
        const form = {
          presentation_id: this.presentationID,
          recipients: this.recipients,
          render: this.recipients.length > 0,
        }
        this.disableEditor()
        shareTemplateService.render(this.form.template_id, form)
          .then(data => {
            this.form.subject = data.subject;
            this.insertContent(data.content, true);
          })
          .catch(err => {
            this.$toast.error('There was a problem rendering the template');
          })
          .finally(() => {
            this.enableEditor();
          })
      } else {
        this.templateName = null;
        this.enableEditor();
      }
    },
    async send() {
      if (this.form.busy) {
        return;
      }
      this.error = null;
      this.form.startProcessing();
      const formData = {
        is_test: this.form.is_test, // MLD-2066
        links: this.links.map(l => l.id),
        presentations: this.links.map(l => l.presentation_id),
        query: this.$route.query, // MLD-2498
        send_receipt: this.form.send_receipt, // MLD-2277
        share_template_id: this.form.template_id ? this.form.template_id : null,
      }
      this.form.html_body = this.getHTMLBody(); // MLD-2412
      const css = this.template ? this.template.css : null; // MLD-2910
      try {
        await emailService.sendEmail(this.recipients, this.form.subject, this.form.html_body, css, formData)
        this.form.finishProcessing();
        await this.deleteDraft();
        if (this.isEnvironmentApp) {
          setTimeout(() => {
            window.location.reload()
          }, 2000);
        } else if (this.redirectBack) {
          this.$router.back();
        } else if (this.redirect) {
          await this.$router.push(this.redirect);
        } else if (this.presentationID) {
          setTimeout(() => {
            this.$router.push({name: 'presentation.info', params: {presentationID: this.presentationID}});
          }, 2000);
        } else {
          this.resetComposeForm();
        }
      } catch (e) {
        this.$toast.error('There was a problem sending the email.');
      } finally {
        this.form.busy = false;
      }
    },
    resetComposeForm() {
      this.insertContent('', true);
      this.clearTemplate();
      this.disableEditor();
      this.deleteDraft();
      this.form.reset();
      this.form.errors.clear();
      this.$refs.form.resetValidation();
      this.form.version = 1;
      this.links = [];
      this.filter.name = '';
      this.filter.type = '';
      this.error = null;
    },
    togglePresentation(presentationID) {
      if (this.form.presentations.includes(presentationID)) {
        //console.log(`Removing ${presentationID}`);
        this.form.presentations = this.form.presentations.filter(id => id !== presentationID);
      } else {
        this.form.presentations.push(presentationID);
      }
    },
    editContact() {
      this.editContactForm = new Form(userContactService.initForm(this.form.contact));
      this.editDialog = true;
      this.editedContact = cloneDeep(this.form.contact);
    },
    closeEditDialog() {
      this.editDialog = false;
      this.editedContact = null;
    },
    saveContact() {
      if (this.editedContact.id) {
        this.editContactForm.put(`/api/user-contacts/${this.editedContact.id}`)
          .then(response => {
            this.form.contact = response.data;
            this.$toast.success('Contact updated');
            this.saveDraft(true);
            this.closeEditDialog();
            this.selectTemplate();
          })
      } else {
        this.editContactForm.post(`/api/user-contacts`)
          .then(response => {
            this.form.contact = response.data;
            this.$toast.success('Contact created');
            this.saveDraft(true);
            this.closeEditDialog();
            this.selectTemplate();
          })
      }
    }
  }
}
</script>
